import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopAppBarComponent } from './top-app-bar.component';
import {
  MdcTopAppBarActionDirective,
  MdcTopAppBarDirective,
  MdcTopAppBarNavIconDirective,
  MdcTopAppBarRowDirective,
  MdcTopAppBarSectionDirective,
  MdcTopAppBarTitleDirective
} from './mdc.top-app-bar.directive';
import {
  MdcListDirective,
  MdcListDividerDirective,
  MdcListGroupDirective,
  MdcListGroupSubHeaderDirective,
  MdcListItemDirective,
  MdcListItemGraphicDirective,
  MdcListItemMetaDirective
} from './mdc.list.directives';
import { MdcIconButtonDirective, MdcRippleDirective } from './mdc.icon-button.directive';

@NgModule({
  imports: [
    TopAppBarComponent,
    MdcTopAppBarDirective,
    MdcTopAppBarRowDirective,
    MdcTopAppBarSectionDirective,
    MdcTopAppBarTitleDirective,
    MdcTopAppBarNavIconDirective,
    MdcTopAppBarActionDirective,

    // MDC list placeholders
    MdcListDirective,
    MdcListItemDirective,
    MdcListItemGraphicDirective,
    MdcListItemMetaDirective,
    MdcListDividerDirective,
    MdcListGroupDirective,
    MdcListGroupSubHeaderDirective,

    // MDC icon button and ripple placeholders
    MdcIconButtonDirective,
    MdcRippleDirective,

    CommonModule
  ],
  //imports: [CommonModule],
  exports: [
    TopAppBarComponent,
    MdcTopAppBarDirective,
    MdcTopAppBarRowDirective,
    MdcTopAppBarSectionDirective,
    MdcTopAppBarTitleDirective,
    MdcTopAppBarNavIconDirective,
    MdcTopAppBarActionDirective,

    // MDC list placeholders
    MdcListDirective,
    MdcListItemDirective,
    MdcListItemGraphicDirective,
    MdcListItemMetaDirective,
    MdcListDividerDirective,
    MdcListGroupDirective,
    MdcListGroupSubHeaderDirective,

    // MDC icon button and ripple placeholders
    MdcIconButtonDirective,
    MdcRippleDirective
  ]
})
export class Cf2TopAppBarNgModule {}
